import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { buildCommittedStateExpiresAt } from 'tripPlanner/assistant/surfaceSnapshots/expiry'
import type { TripPlannerCommittedStateEntry } from 'tripPlanner/assistant/surfaceSnapshots/committedStateEntry'
import type { ListingDrawerHotelDateSelection } from '../ListingDrawerSearchDates'
import { formatHotelSearchDisplayText } from './formatHotelSearchDisplayText'

// Retain one last search per stop, plus one explicit stopless scope.
export function buildLastHotelSearchCommittedStateEntry(
  stopId: number | undefined,
  searchQuery: string,
  dateSelection: ListingDrawerHotelDateSelection,
  occupancies: Array<App.Occupants>,
  filters: App.OfferListFilters,
): TripPlannerCommittedStateEntry {
  return {
    key: stopId === undefined ? 'search:hotel:unscoped' : `search:hotel:stop:${stopId}`,
    kind: 'last_hotel_search',
    label: 'Last hotel search',
    displayText: boundActivityDisplayText(formatHotelSearchDisplayText(searchQuery, dateSelection, occupancies, filters)),
    sourcePath: 'trip_planner.search.hotel',
    dataClassification: 'personalised_surface',
    expiresAt: buildCommittedStateExpiresAt(),
  }
}
